
<!--
 * @Descripttion: 分栏
 * @Author: zenghua.wang
 * @Date: 2021-04-14 10:01:52
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-24 16:39:11
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
  >
    <draggable
      :class="setClass('item')"
      v-for="(_, index) in option.cols"
      :style="[styleFlex(index), styleMargin(index)]"
      :key="index"
      :list="temp"
      :group="{ name: 'form' }"
      ghost-class="ghost"
      :disabled="disabled"
      :animation="200"
      filter=".drag-column-item"
      @add="onWidgetColumnAdd($event, index)"
    >
      <!-- 分栏组件包含的其他组件 -->
      <template v-if="children[index] && children[index].label">
        <div
          :class="setClass('item__content')"
          :style="styleInline(children[index])"
          @click.stop="onSelectWidgetColumn(index)"
        >
          <!-- 动态组件占位 -->
          <component
            :is="`drag-${children[index].type}`"
            :id="children[index].prop"
            :label="children[index].label"
            :apiId="children[index].apiId"
            :width="children[index].width"
            :height="children[index].height"
            :option="children[index].option"
            :children="children[index].children"
            :page="children[index].page"
            :index="index"
            :disabled="disabled"
            :select.sync="select"
            @change="$emit('change')"
          >
          </component>

          <div
            :class="setClass('item__action')"
            v-if="selectWidget && selectWidget.prop == children[index].prop &&!disabled"
          >
            <el-button
              title="删除"
              @click.stop="onWidgetColumnDelete(index)"
              circle
              plain
              size="small"
              type="danger"
            >
              <i class="el-icon-delete"></i>
            </el-button>
          </div>
        </div>
      </template>

      <!-- 占位符-->
      <div
        v-else
        class="drag-empty"
        :style="styleVisible"
      />

    </draggable>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import bem from '@/dragComponents/mixins/bem'
import { component } from '@/dragComponents/model/default.js'
import { createId, deepClone, isEmpty, setPx } from '@/dragComponents/utils'

export default {
  name: 'drag-column',
  mixins: [bem],
  components: {
    draggable
  },
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    children: {
      type: Array,
      default: () => {
        return []
      }
    },
    temp: {
      type: Array,
      default: () => {
        return []
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: [Number, String]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectWidget: this.select
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              padding: design.padding,
              background: design.bg,
              border: (() => {
                return this.styleActive ? design.activeSolid : design.solid
              })()
            }
          }
          return {}
        })(),
        {
          flexDirection:
            this.device === 'desktop'
              ? this.option.direction === 'row'
                ? 'row'
                : 'column'
              : 'column',
          borderRadius: setPx(this.option.borderRadius),
          background: this.option.backgroundColor
        }
      )
    },
    styleActive() {
      return !this.disabled && this.selectWidget.prop === this.id
    },
    styleFlex() {
      const { design } = component
      return (index) => {
        let flex = index === 0 ? this.option.leftCol : this.option.rightCol
        return Object.assign(
          (() => {
            // 设计时
            if (!this.disabled) {
              return {
                minHeight: '100px',
                border: isEmpty(this.children[index]) ? design.dashed : 0,
                background: isEmpty(this.children[index])
                  ? design.emptyBg
                  : 'none'
              }
            }
            return {}
          })(),
          {
            flex: flex,
            padding: this.device === 'desktop' ? setPx(this.option.padding) : 0
          }
        )
      }
    },
    styleInline() {
      return (item) => {
        let block = (component.inlineList || []).includes(item.type)
          ? 'inline-block'
          : 'block'
        return {
          display: block
        }
      }
    },
    styleVisible() {
      return {
        display: this.disabled ? 'none' : 'block'
      }
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val) {
        this.$emit('update:select', val)
      },
      deep: true
    }
  },
  methods: {
    styleMargin(index) {
      let gap = index === 0 ? setPx(this.option.gap) : 0
      return Object.assign(
        (() => {
          if (this.option.direction === 'row') {
            return {
              marginRight: this.device === 'desktop' ? gap : 0
            }
          }
          if (this.option.direction === 'column') {
            return {
              marginBottom: this.device === 'desktop' ? gap : 0
            }
          }
          return {}
        })(),
        {}
      )
    },
    onWidgetColumnAdd(e, columnIndex) {
      let newIndex = e.newIndex
      // 分栏中不允许拖入分栏和网格
      if (
        this.temp[newIndex] &&
        !['grid', 'column'].includes(this.temp[newIndex].type)
      ) {
        // 获取temp中数据根据栏位置set children
        const item = deepClone(this.temp[newIndex])
        if (!item.prop) item.prop = createId(item.type)
        this.$set(this.children, columnIndex, item)
        this.$emit('change')
        this.selectWidget = this.children[columnIndex]
      }
    },
    onSelectWidgetColumn(index) {
      this.selectWidget = this.children[index]
    },
    onWidgetColumnDelete(index) {
      this.$confirm(`是否删除所选组件?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$nextTick(() => {
            if (this.temp) this.temp.splice(index, 1)
            this.$set(this.children, index, {})
            this.$emit('change')
            this.selectWidget = {}
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang='scss' scoped>
@import '@/dragComponents/styles/variables.scss';

.drag-column {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden;

  &-item {
    flex: 1;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    text-align: left;

    &__content {
      position: relative;
    }

    &__action {
      position: absolute;
      bottom: 0px;
      right: 0px;
      z-index: 1001;

      i {
        font-size: 14px;
      }
    }
  }
}
</style>
